<div class="tab-container">
  <button
    *ngFor="let opt of toggleOptions"
    class="no-style-button tab"
    [ngClass]="{ active: selectedValue === opt.value }"
    (click)="onSelect(opt.value)">
    {{ opt.label }}
  </button>
</div>
